/**
 * GlowIcon — значок-плитка с изумрудным градиентом и мягким свечением.
 * Размер, скругление и содержимое задаются снаружи через className и children.
 */
import type { ReactNode } from "react";

export function GlowIcon({ className = "", children }: { className?: string; children: ReactNode }) {
  return (
    <div className="relative inline-grid place-items-center">
      <div className="absolute -inset-3 rounded-full bg-brand/40 blur-2xl" />
      <div
        className={`relative grid place-items-center bg-gradient-to-br from-brand-400 to-brand-600 text-surface-base shadow-xl shadow-brand/50 ${className}`}
      >
        {children}
      </div>
    </div>
  );
}